const coaches = state => state.coaches;

const coach = state => state.coach;

const coachesLoading = state => state.coachesLoading;

const coachLoading = state => state.coachLoading;

const coachesMeta = state => state.meta;

const coachMail = state => state.coachMail;

const coachMailLoading = state => state.coachMailLoading;

const deleteImages = state => state.deleteImages;

const deleteImagesLoading = state => state.deleteImagesLoading;

const singleCoach = state => state.singleCoach;

const singleCoachLoading = state => state.singleCoachLoading;

export default {
  coach,
  coaches,
  coachesLoading,
  coachLoading,
  coachesMeta,
  coachMail,
  coachMailLoading,
  deleteImages,
  deleteImagesLoading,
  singleCoach,
  singleCoachLoading
};
